import styled from 'styled-components';

import { CellContext, Row } from '@tanstack/react-table';

import { colors } from 'styles/theme/colors';
import ChevronRight from 'svg/ChevronRight';

export const Chevron = styled(ChevronRight).attrs({ width: 12, height: 12 })<{ $expanded: boolean }>`
  flex-shrink: 0;
  transform: ${({ $expanded }) => ($expanded ? 'rotate(90deg)' : 'none')};
  transition: transform 0.15s ease;
`;

export const ExpandButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  min-width: 0;
  padding: 0;
  font: inherit;
  font-weight: 700;
  letter-spacing: 0.18px;
  color: ${({ theme }) => theme.colors.black};
  text-align: left;
  white-space: nowrap;

  & > svg {
    flex-shrink: 0;
  }
  & > span {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  &:hover {
    color: ${({ theme }) => theme.colors.black75};
  }
`;

export const LeafName = styled.span`
  display: inline-block;
  max-width: 100%;
  color: ${({ theme }) => theme.colors.black};
  font-weight: 700;
  letter-spacing: 0.18px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const SubRowName = styled.span`
  display: inline-block;
  max-width: 100%;
  padding-left: 26px;
  color: ${({ theme }) => theme.colors.black};
  letter-spacing: 0.18px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TableWrapper = styled.div`
  td:first-child:not(:last-child),
  th:first-child {
    border-right: 1px solid ${({ theme }) => theme.colors.black10};
  }
`;

export function buildEntityCell<T extends { isSubRow?: boolean }>(info: CellContext<T, string>) {
  const row = info.row.original;
  const value = info.getValue();

  if (row.isSubRow) return <SubRowName>{value}</SubRowName>;
  if (!info.row.getCanExpand()) return <LeafName>{value}</LeafName>;

  const isExpanded = info.row.getIsExpanded();
  return (
    <ExpandButton type='button' aria-expanded={isExpanded} onClick={() => info.row.toggleExpanded()}>
      <Chevron $expanded={isExpanded} />
      <span>{value}</span>
    </ExpandButton>
  );
}

export function subRowStyle<T extends { isSubRow?: boolean }>(row: Row<T>) {
  return row.original.isSubRow ? { backgroundColor: colors.black05 } : undefined;
}
